import { render, staticRenderFns } from "./PageAudioConfig.vue?vue&type=template&id=0c5f0e2a"
import script from "./PageAudioConfig.vue?vue&type=script&lang=js"
export * from "./PageAudioConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports